<template>
  <div class="col-md-6 col-sm-6 col-xs-6 q-pr-md">
    <q-table
      style="height: 500px"
      flat
      table-header-class="bg-accent text-width-bold"
      :rows="listaFerramentas"
      dense
      :columns="columns"
      :loading="disable"
      :rows-per-page-options="[0]"
      hide-pagination
      class="q-mt-sm tabela-tamanho-fixo"
      hide-bottom
      selection="single"
      row-key="uuid"
      v-model:selected="selected"
      no-data-label
      @request="handleRequest"
    >
      <template v-slot:top>
        <section class="row col-12 items-center justify-between align">
          <div class="row">
            <span class="text-h6 text-brand-5">Selecione a Ferramenta</span>
          </div>

          <q-input
            class="q-pl-md"
            rounded
            outlined
            dense
            debounce="300"
            v-model="filter"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search"></q-icon>
            </template>
          </q-input>
        </section>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "vue";
//import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "SelectComponentResponsaveis",
  props: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();
    //const router = useRouter();
    const unidade = ref({
      id: "",
      nome: "",
    });
    const filter = ref("");
    const disable = ref(true);
    const selected = ref([]);
    const listaUnidades = ref([]);
    const listaFerramentas = ref([]);

    const selecionaImagem = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });

    const columns = [
      {
        name: "nome",
        label: "Nome da Ferramenta",
        field: "nome",
        align: "left",
      },

      {
        name: "patrimonio",
        label: "Patrimonio",
        field: (row) => row.patrimonio,
        align: "left",
      },
      {
        name: "status",
        label: "Status Atual",
        field: "status",
        align: "left",
        sortable: true,
      },
    ];

    let listar = async () => {
      disable.value = true;
      listaFerramentas.value = [];
      try {
        let resposta = await store.dispatch("fer/listarFerramentasChecklist", {
          deposito: store.state.org.unidadeData.id,
          filtro: filter.value,
          per_page: 6,
        });

        listaFerramentas.value = resposta.resposta.data.result;
        disable.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    onMounted(() => {
      listar();
    });

    watch(
      () => selected.value,
      () => {
        emit("selectValue", selected.value);
      }
    );

    watch(
      () => filter.value,
      () => {
        listar();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          listar();
        }, 1000);

        selected.value = [];
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        listar();
      }
    );

    const handleRequest = async () => {
      listar(pagination.value.page, pagination.value.rowsPerPage);
    };

    return {
      unidade,
      selecionaImagem,
      listaFerramentas,
      listaUnidades,
      columns,
      selected,
      disable,

      filter,
      handleRequest,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
  justify-content: space-between;
}
</style>
